import { Amm } from '../types';

const SUPPORT_MULTI_HOP_AMM_LABELS = ['Ref.Finance', 'Jumbo'];

const checkIsMultiHopOnSameAMM = (amms: Amm[]) => {
  const isSameAmmMultiRoute =
    amms.length > 1 && amms[0].label === amms[1].label; // we have max 2 steps for now

  if (!isSameAmmMultiRoute) {
    return false;
  }

  const isSupported = amms.every((amm) =>
    SUPPORT_MULTI_HOP_AMM_LABELS.some(
      (supportedAmmLabel) => amm.label === supportedAmmLabel
    )
  );

  if (!isSupported) {
    return false;
  }

  return true;
};

export { checkIsMultiHopOnSameAMM };
